import { gql } from "apollo-boost";
import { useCallback, useRef, useState } from "react";

export const GET_PRODUCT_WITH_VARIANTS = gql`
  query productByID($id: ID!) {
    productByID(id: $id) {
      id
      productBases {
        shippingOptions {
          id
          name
        }
        defaultShippingOptionId
        id
        }
      variants {
        id
        disabled
        productBaseVariantId
        productBaseVariant {
          id
          fulfillmentProductId
          fulfillmentSku
          attributes {
            name
            slug
            option
          }
          fulfillmentWarehouses
          productBase {
            id
            title
          }
        }
      }
    }
  }
`;

export function useProductVariants() {
  const [l, setL] = useState(false);
  const [error, setError] = useState(null);
  const getVariants = useCallback(async (product) => {
    const { __apolloClient__: client } = window || {};
    if (!product || !client) return product;

    setL(true);
    setError(null);

    const { id } = product;
    try {
      const { data } = await client.query({
        query: GET_PRODUCT_WITH_VARIANTS,
        variables: { id },
      });
      if (data?.productByID) {
        product.variants = data.productByID.variants;
      }

      setL(false);
      return product;
    } catch (err) {
      setError(err);
    }
  }, []);

  return [getVariants, l, error];
}
